module.exports = __webpack_public_path__ + "img/diplome.d98a49d8.png";